import { render, staticRenderFns } from "./heads.vue?vue&type=template&id=6c39e062&scoped=true&"
import script from "./heads.vue?vue&type=script&lang=js&"
export * from "./heads.vue?vue&type=script&lang=js&"
import style0 from "./heads.vue?vue&type=style&index=0&id=6c39e062&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c39e062",
  null
  
)

export default component.exports